import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardActions,
  CardHeader,
  CardContent,
  Divider,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import {Schedule as ScheduleIcon} from '@material-ui/icons';
import {purple} from '@material-ui/core/colors';

const purple500 = purple[500];

function ProjectProperties(props) {
  const {selectedProject, onProjectImport} = props;

  if (!!selectedProject) {
    return (
      <Card>
        <CardHeader title={selectedProject.name} subheader="Properties" />
        <Divider />
        <CardContent style={{overflow: 'auto', whiteSpace: 'nowrap'}}>
          <List>
            <ListItem style={{wordWrap: 'break-word', whiteSpace: 'normal'}}>
              <ListItemIcon>
                <ScheduleIcon />
              </ListItemIcon>
              <ListItemText
                primary="Created Date"
                secondary={new Date(selectedProject.createdDt).toLocaleDateString('en-AU')}
              />
            </ListItem>
            <ListItem style={{wordWrap: 'break-word', whiteSpace: 'normal'}}>
              <ListItemIcon>
                <ScheduleIcon />
              </ListItemIcon>
              <ListItemText
                primary="Last Modified Date"
                secondary={new Date(selectedProject.modifiedDt).toLocaleDateString('en-AU')}
              />
            </ListItem>
          </List>
        </CardContent>
        <CardActions>
          <Button variant="outlined" onClick={onProjectImport} style={{color: purple500}}>
            Import
          </Button>
        </CardActions>
      </Card>
    );
  } else {
    return (
      <Card>
        <CardHeader title="Project Properties" subheader="No Project Selected" />
      </Card>
    );
  }
}

ProjectProperties.propTypes = {
  selectedProject: PropTypes.object,
  onProjectImport: PropTypes.func.isRequired,
};

ProjectProperties.defaultProps = {
  selectedProject: null,
};

export default ProjectProperties;
